import { rpcCall } from '@scayle/storefront-nuxt'
import type { CustomerData } from '~/types/tracking'

const useTrackingUserPayload = () => {
  const { user, isLoggedIn, customerType } = useAgsUser()
  const currentShop = useCurrentShop()
  const nuxtApp = useNuxtApp()

  const getUserPayload = async (
    fallbackEmail = '',
  ): Promise<
    CustomerData | Pick<CustomerData, 'login_status' | 'user_type'>
  > => {
    const loginStatus = isLoggedIn.value ? 'logged_in' : 'logged_out'
    if (!user.value) {
      return { login_status: loginStatus, user_type: 'new' }
    }

    const email = user.value?.email || fallbackEmail

    const emailHash = await rpcCall(
      nuxtApp,
      'encryptText',
      currentShop.value,
    )({ email })
    const eh = await getEmailHash(email)

    return {
      user_id: user.value.id,
      emailHash,
      eh,
      customer_type: customerType.value,
      login_status: loginStatus,
      user_type: 'registered',
    }
  }

  return { getUserPayload }
}

export default useTrackingUserPayload
